import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class PayrollField extends DomainObject {
  complete;
  name;
  newValue;
  oldValue;

  constructor(other) {
    super();

    makeObservable(this, {
      complete: observable,
      name: observable,
      newValue: observable,
      oldValue: observable
    });

    this.merge(other);
  }
}

export default PayrollField;
